import React, { Component } from 'react';
import { connect } from 'react-redux'
import {closePopup} from "../../actions/popup";
import autobind from 'autobind-decorator'
import CommentBlockPopup from '../../components/comments/comment/CommentBlockPopup'
import CommentReplyPopup from '../../components/comments/comment/CommentReplyPopup'
import WindowEventHelper from "../../lib/WindowEventHelper";

@connect(state => ({
    isPopupOpened: (typeof state.popup !== 'undefined' && state.popup.isCommentReplyPopupOpened)
    || (typeof state.popup !== 'undefined' && state.popup.isCommentBlockPopupOpened)
}), dispatch => ({
    handlePopupClose: () => {
        dispatch(closePopup())
    },
}))
class CommentPopupLayer extends Component {
    componentWillUnmount() {
        document.body.className = "";
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isPopupOpened) {
			WindowEventHelper.add("keydown", this.handleKeyDown)

            document.body.className = "scroll_hide";
        }
        else {
			WindowEventHelper.remove("keydown", this.handleKeyDown)

            document.body.className = "";
        }
    }


    @autobind
    handleKeyDown(e) {
        const keyCode = e.keyCode;
        const tagName = e.target.tagName;
        if (keyCode == 27) {
            this.props.handlePopupClose();
        }
    }

    render() {
        const divStyle = {position: 'fixed', display: this.props.isPopupOpened?'block':'none'};
        return (
            <div className="container_layer" style={divStyle}>
                <CommentBlockPopup />
                <CommentReplyPopup />
            </div>
        );
    }
}

export default CommentPopupLayer
